module.exports = __webpack_public_path__ + "img/阿基-钱伯斯.557276c9.png";